import React, { useEffect } from 'react';
import { auth } from '../firebase-config'; // Import Firebase auth
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css'; // Import FirebaseUI CSS
import {
  EmailAuthProvider,
  GoogleAuthProvider,
  FacebookAuthProvider,
  TwitterAuthProvider,
  GithubAuthProvider,
  PhoneAuthProvider
} from 'firebase/auth'; // Import all necessary auth providers

function Login() {
  useEffect(() => {
    // FirebaseUI config with multiple providers, including anonymous login
    const uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          // User signed in successfully, display a custom message
          document.getElementById('firebaseui-auth-container').innerHTML = `
            <h2>Welcome, ${authResult.user.displayName || 'User'}!</h2>
            <p>You have successfully signed in.</p>
          `;
          return false; // Prevent redirect
        },
        signInFailure: function(error) {
          console.error("Sign in failed: ", error);
        },
        uiShown: function() {
          // Hide the loader once UI is shown
          document.getElementById('loader').style.display = 'none';
        }
      },
      signInFlow: 'popup', // Use popup instead of redirect
      signInOptions: [
        EmailAuthProvider.PROVIDER_ID,
        GoogleAuthProvider.PROVIDER_ID,
        FacebookAuthProvider.PROVIDER_ID,
        TwitterAuthProvider.PROVIDER_ID,
        GithubAuthProvider.PROVIDER_ID,
        PhoneAuthProvider.PROVIDER_ID,
        firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID // Add anonymous sign-in
      ],
      tosUrl: '/terms-of-service', // Terms of Service URL
      privacyPolicyUrl: '/privacy-policy', // Privacy Policy URL
    };

    // Initialize FirebaseUI
    let ui;
    if (firebaseui.auth.AuthUI.getInstance()) {
      ui = firebaseui.auth.AuthUI.getInstance();
    } else {
      ui = new firebaseui.auth.AuthUI(auth);
    }

    // Start the FirebaseUI auth interface
    ui.start('#firebaseui-auth-container', uiConfig);

    // Cleanup on component unmount
    return () => {
      ui.reset();
    };
  }, []);

  return (
    <div className="login-page">
      <div>&nbsp;</div>
      <div id="firebaseui-auth-container"></div> {/* FirebaseUI auth container */}
      <div id="loader">Loading...</div> {/* Loader before UI is shown */}
    </div>
  );
}

export default Login;









